import React, { useEffect, useState } from 'react';

import Verify from '../../../components/Verify';
import { observer } from 'mobx-react';
import UserStore from 'stores/UserStore';
import { Mobile as MobileComponent } from '@partsbadger/library';
import Remove from 'components/MobileActions/Remove';
import { Card, List, Tag, Button, Tooltip } from 'antd';
import { ContactProps } from 'types/types';

import UIStore from '@/stores/UIStore';
import ComingSoonFeaturesStore from 'stores/ComingSoonFeaturesStore';
import dayjs from 'dayjs';

const ManageMobile: React.FC = () => {
    const [loading, setLoading] = useState<boolean>(false);
    const [contactDataLoaded, setContactDataLoaded] = useState<boolean>(false);
    const [data, setData] = useState<ContactProps[]>([]);

    if (!UserStore.isVerified) {
        return <Verify />;
    }

    const contact = UserStore.user && UserStore.user.default_contact ? UserStore.user.default_contact : null;

    useEffect(() => {
        UIStore.setSelectedKey(['mobile']);
        UIStore.setDocumentTitle('Mobile');
        async function getData() {
            if (contact) {
                setLoading(true);

                UserStore.getContact(contact.id)
                    .then(resp => {
                        const data = [resp];

                        setData(data);
                        setContactDataLoaded(true);
                        setLoading(false);
                    });
                return;
            }

            setContactDataLoaded(true);
        }

        getData();
    }, []);

    const updateData = () => {
        if (contact) {
            UserStore.getContact(contact.id).then(data => {
                setData([data]);
            });
        }
    };

    const handleRemove = (index: number) => {
        const dataSource = [...data];
        dataSource.splice(index, 1);
        setData(dataSource);
    };

    const handleChangeSmsNotification = (value: any) => {
        const oldData = [...data];
        oldData[0].sms_notifications = value;
        setData(oldData);
    };

    return (
        <section data-testid="page-customer-settings-mobile" data-ready={!loading && contactDataLoaded ? 'true' : 'false'}>
            <p className="text-md font-normal pb-2 pt-3">
                Register your mobile phone number to send SMS the status of the quote
            </p>
            <Card title="Manage Mobile" bordered data-testid="customer-settings-mobile-panel">
                <List
                    data-testid="customer-settings-mobile-list"
                    data-ready={!loading && contactDataLoaded ? 'true' : 'false'}
                    itemLayout="horizontal"
                    dataSource={data}
                    renderItem={(item, index) => {
                        const actions = [];
                        if (item.sms_verified) {
                            actions.push(<Tag color="#87d068">Verified</Tag>);
                            actions.push(
                                <Remove
                                    id={item.id}
                                    updateData={updateData}
                                    handleRemove={handleRemove}
                                    mobile={item.mobile}
                                    index={index}
                                />
                            );
                        } else if (item.sms_notifications && item.sms_verified === false) {
                            actions.push(<Tag color="#e8b878">Pending Verified</Tag>);
                            actions.push(
                                <Remove
                                    id={item.id}
                                    updateData={updateData}
                                    handleRemove={handleRemove}
                                    mobile={item.mobile}
                                    index={index}
                                />
                            );
                        }
                        return (
                            <List.Item
                                key={index}
                                actions={actions}
                                data-testid="customer-settings-mobile-row"
                                data-contact-id={item.id}
                                data-sms-notifications={item.sms_notifications ? 'true' : 'false'}
                                data-sms-verified={item.sms_verified ? 'true' : 'false'}
                            >
                                <List.Item.Meta title={item.mobile} />
                            </List.Item>
                        );
                    }}
                />
                <>
                    {data.length > 0 && (
                        <MobileComponent
                            updateData={updateData}
                            contact={data[0]}
                            onChangeSmsNotification={handleChangeSmsNotification}
                        />
                    )}
                </>
            </Card>
            <p className="text-md font-normal pb-2 pt-3">Receive updates and ask us questions right from your slack</p>
            <Card title="Slack" bordered>
                <Button
                    className="ant-btn-xs"
                    id="connect-your-slack"
                    onClick={() => {
                        ComingSoonFeaturesStore.setModalHeader(`Coming Soon in ${dayjs().year()}`);
                        ComingSoonFeaturesStore.setModalTextContent(
                            'Receive updates and ask us questions right from your slack.'
                        );
                        ComingSoonFeaturesStore.setModalVisible(true);
                    }}
                >
                    Connect Your Slack
                </Button>
            </Card>
            <p className="text-md font-normal pb-2 pt-3">
                Easily manage your production needs by connecting your ERP to your PartsBadger account
            </p>
            <Card title="ERP" bordered>
                <Button
                    className="ant-btn-xs"
                    id="integrate-your-erp"
                    onClick={() => {
                        ComingSoonFeaturesStore.setModalHeader(`Coming Soon in ${dayjs().year()}`);
                        ComingSoonFeaturesStore.setModalTextContent(
                            'Easily manage your production needs by connecting your ERP to your PartsBadger account.'
                        );
                        ComingSoonFeaturesStore.setModalVisible(true);
                    }}
                >
                    Integrate Your ERP
                </Button>
            </Card>
        </section>
    );
};

export default observer(ManageMobile);
